import { apiGet } from '../api';
import type { DiscoveredApp } from '../types';
import { esc } from '../util';

/** Render the app list page with status indicators. */
export function renderApps(container: HTMLElement): void {
  container.innerHTML = `
    <div class="apps-page">
      <h2 class="page-title">Apps</h2>
      <div id="app-list" class="app-list">
        <div class="skeleton-card"><div class="skeleton-line"></div><div class="skeleton-line"></div></div>
        <div class="skeleton-card"><div class="skeleton-line"></div><div class="skeleton-line"></div></div>
        <div class="skeleton-card"><div class="skeleton-line"></div><div class="skeleton-line"></div></div>
      </div>
    </div>
  `;

  loadAppList(container);
}

async function loadAppList(container: HTMLElement): Promise<void> {
  const list = container.querySelector<HTMLElement>('#app-list');
  if (!list) return;

  try {
    const apps = await apiGet<DiscoveredApp[]>('/api/discover');
    list.innerHTML = '';

    if (apps.length === 0) {
      list.innerHTML = '<p class="empty-text">No apps found</p>';
      return;
    }

    for (const app of apps) {
      const row = document.createElement('div');
      row.className = 'app-row';
      const statusClass = app.status === 'running' ? 'status-online' : 'status-offline';
      row.innerHTML = `
        <div class="app-row-icon ${statusClass}"></div>
        <div class="app-row-info">
          <span class="app-row-name">${esc(app.name)}</span>
          <span class="app-row-desc">${esc(app.description)}</span>
        </div>
        <span class="app-row-status">${esc(app.status)}</span>
      `;
      row.addEventListener('click', () => {
        window.location.href = `/api/proxy/${encodeURIComponent(app.id)}/index.html`;
      });
      list.appendChild(row);
    }
  } catch {
    list.innerHTML = '<p class="empty-text">Could not load apps</p>';
  }
}

